var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader"},[_c('span',{style:({ backgroundColor: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }